import { useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { selectParamsSetting } from '../../../../common/filterCompany/store/slice'
import { selectIsAllCheck } from '../../../../common/filterCompany/store/slicePortfolio'
import {
  changeFilter,
  selectCompanyDetailCell,
  selectCompanyDetailIds,
  selectCompanyDetailPagination,
  selectDisplayType,
  selectFilter,
  selectListCompanyDetailLoading,
} from '../../store/slice'
import { postOrganizationInfo } from '../../store/thunk'

const usePopupData = () => {
  const dispatch = useDispatch()

  const isAll = useSelector(selectIsAllCheck)
  const settingParams = useSelector(selectParamsSetting)
  const filter = useSelector(selectFilter)
  const displayType = useSelector(selectDisplayType)
  const popupLoading = useSelector(selectListCompanyDetailLoading)

  const portfolioSettingParams = useMemo(() => {
    return {
      ...settingParams,
      portfolioIds: isAll ? [] : settingParams.portfolioIds,
    }
  }, [settingParams, isAll])

  const getListCompany = () => {
    const params = {
      ...portfolioSettingParams,
      ...filter,
      companyType: displayType,
    }

    const thunk = () => {
      dispatch(postOrganizationInfo(params))
    }

    const dependencies = [portfolioSettingParams, filter, displayType]

    return { thunk, dependencies }
  }

  const setPage = (value) => {
    dispatch(
      changeFilter({
        page: value,
      }),
    )
  }

  const setPageSize = (value) => {
    dispatch(
      changeFilter({
        pageSize: value,
        page: 1,
      }),
    )
  }

  return {
    getListCompany,
    setPage,
    setPageSize,
    popupLoading,
    selectIds: selectCompanyDetailIds,
    selectDataFromRedux: selectCompanyDetailCell,
    selectPaginationInfo: selectCompanyDetailPagination,
  }
}

export default usePopupData
